// extracted by mini-css-extract-plugin
export default {"header":"AQ-z","isActive":"BQ-z"};